import { Injectable } from '@angular/core';
import { License, ResponseLicense } from '../models/license.model';
import { adaptRequestLicense } from '../adapters/adapt-request.adapter';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  private licenseBehaviorSubject = new BehaviorSubject<License | undefined>(
    undefined
  );

  constructor(private router: Router, private http: HttpClient) { }

  // Esto se ejecuta en el guard no volver a utilizar
  async startPeriodicCheck(intervalMs: number): Promise<void> {
    let countInteractions = 0;

    while (true) {
      const existingPermissionList = localStorage.getItem('PermissionList');

      try {
        // Hasta que no tengamos los permisos del usuario reiteramos cada 3600 milisegundos
        if (!existingPermissionList) {
          console.log('(LICENSE) no existen permisos');
          countInteractions++;

          // Si llegamos a 10 interacciones sin permisos, recargar la página
          if (countInteractions >= 5) {
            console.log(
              '(LICENSE) Recargando página después de 10 intentos sin permisos'
            );
            window.location.reload();
            return;
          }

          await this.delay(3600);
          continue;
        }
        const content: string[] = JSON.parse(existingPermissionList ?? '[]');
        console.log('(LICENSE) permisos service', content);
        if (!content.some((permission) => permission === 'license_module')) {
          console.log(
            '(LICENSE) no tiene permisos habilitados este usuario servicio'
          );
          break;
        }

        const licenseInfo = await this.checkLicense();
        console.log('(LICENSE) Verificación periódica:', licenseInfo);
        // console.log('(LICENSE) path', this.router.url);

        // Si la licencia no es válida, o el tiempo restante es menor o igual a 0, redirigir a la página de licencia
        if (!licenseInfo.isLicenseValid || licenseInfo.remainingTime <= 0) {
          this.router.navigate(['/license']);
          break;
        }

        await this.delay(intervalMs);
      } catch (error) {
        console.error('Error en verificación periódica:', error);
      }
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async checkLicense(): Promise<License> {
    try {
      const response = await this.getLicense();
      if (!response.status) {
        console.error('(LICENSE) error en la request');
        return {
          isLicenseValid: false,
          remainingTime: 0,
          licenseExpirationDate: '',
        };
      }
      const license = adaptRequestLicense(response);
      this.setStateLicense = license;
      return license;
    } catch (error) {
      console.error('Error al verificar licencia:', error);
      return {
        isLicenseValid: false,
        remainingTime: 0,
        licenseExpirationDate: '',
      };
    }
  }

  async checkLicensePublic(): Promise<License> {
    return await this.getLicense().then((response) => {
      if (!response.status) {
        return {
          isLicenseValid: false,
          remainingTime: 0,
          licenseExpirationDate: '',
        };
      }
      return adaptRequestLicense(response);
    });
  }

  getLicense(): Promise<ResponseLicense> {
    return this.http
      .post<ResponseLicense>(environment.apiUrl + '/api/getLicense', {})
      .toPromise();
  }

  get getStateLicense() {
    return this.licenseBehaviorSubject.asObservable();
  }

  set setStateLicense(license: License) {
    this.licenseBehaviorSubject.next(license);
  }

  public getRemainingTime(): string {
    const lic = this.licenseBehaviorSubject.getValue();
    return lic
      ? this.formatRemainingTime(lic)
      : "Sin licencia activa";
  }
  public formatRemainingTime(license: License): string {
    let seconds = license.remainingTime;

    const units = [
      { label: "mes", seconds: 30 * 24 * 60 * 60 },
      { label: "día", seconds: 24 * 60 * 60 },
      { label: "hora", seconds: 60 * 60 },
      { label: "minuto", seconds: 60 },
      { label: "segundo", seconds: 1 },
    ];

    const parts: string[] = [];

    for (const unit of units) {
      if (seconds >= unit.seconds) {
        const value = Math.floor(seconds / unit.seconds);
        seconds %= unit.seconds;
        parts.push(`${value} ${unit.label}${value > 1 ? "s" : ""}`);
      }
      if (parts.length === 2) break; // máximo 2 valores
    }

    return parts.length > 0 ? parts.join(" ") : "Expirada";
  }
}
